import { render } from "./Namapemilik.vue?vue&type=template&id=ad99c332"
import script from "./Namapemilik.vue?vue&type=script&lang=js"
export * from "./Namapemilik.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__